var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScreensHigh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 147.38 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1-screen-high{fill:#7eac20;}.cls-2-screen-high{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-high",
    d: "M24.65,103.79h-10a3.88,3.88,0,0,1-3.88-3.88V80.17a3.88,3.88,0,0,1,3.88-3.88h10a3.88,3.88,0,0,1,3.88,3.88V99.91a3.9,3.9,0,0,1-3.75,3.87Zm-10-24.5a.88.88,0,0,0-.88.88V99.91a.89.89,0,0,0,.88.88h10a.87.87,0,0,0,.84-.87V80.17a.88.88,0,0,0-.88-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-high",
    d: "M27,81.77H12.3a.35.35,0,0,1-.35-.35c0-.2.16-.36.35.64H27c.19-1,.35-.84.35-.64A.35.35,0,0,1,27,81.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-high",
    d: "M27.85,83.06H11.48l-.13-.69a1.31,1.31,0,0,1-.4-1,1.09,1.09,0,0,1,1-1.14,1,1,0,0,1,1,.49H26.43a1,1,0,0,1,1-.49,1.09,1.09,0,0,1,1,1.14,1.35,1.35,0,0,1-.39,1Zm.27-1.25Zm-16.91,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-high",
    d: "M27.38,98.57H12.66a.35.35,0,1,1,0-.7H27.38a.35.35,0,1,1,0,.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-high",
    d: "M27.38,99.2H12.66a1,1,0,1,1,0-2H27.38a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-high",
    d: "M94,37.54a1.19,1.19,0,0,1-.68-.21L67.9,19.48a1.18,1.18,0,1,1,1.35-1.93L93.59,34.67a.84.84,0,0,0,.89,0l10.11-5.62a1.18,1.18,0,1,1,1.14,2.06L94.52,37.39A1.16,1.16,0,0,1,94,37.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-high",
    d: "M94,37.92a1.51,1.51,0,0,1-.9-.29L67.68,19.79a1.56,1.56,0,0,1,1.79-2.55L93.8,34.36a.46.46,0,0,0,.5,0l10.1-5.63a1.56,1.56,0,0,1,1.18-.14,1.59,1.59,0,0,1,.94.74,1.56,1.56,0,0,1-.6,2.12L94.71,37.72A1.57,1.57,0,0,1,94,37.92ZM68.58,17.71a.79.79,0,0,0-.66.34.77.77,0,0,0-.14.6.83.83,0,0,0,.33.52L93.49,37a.81.81,0,0,0,.85,0l11.21-6.25a.79.79,0,0,0,.31-1.09.78.78,0,0,0-.48-.39.86.86,0,0,0-.61.07L94.67,35a1.22,1.22,0,0,1-1.3-.07L69,17.86A.79.79,0,0,0,68.58,17.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-screen-high",
    d: "M57.14,43.22A2.26,2.26,0,0,1,59.46,41h69a2.26,2.26,0,0,1,2.32,2.19V63.14a1.51,1.51,0,0,1-3,0V44.28a.41.41,0,0,0-.43-.38H60.59a.42.42,0,0,0-.44.38v9.2H78.5a2.7,2.7,0,0,1,2.69,2.69V82.38h46.12a.41.41,0,0,0,.43-.38V73.38a1.51,1.51,0,0,1,3,0v9.68a2.26,2.26,0,0,1-2.32,2.19H81.19v3.17h52.38V37.86H54.33V53.48h2.81Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-screen-high",
    x: 73.5,
    y: 85.25,
    width: 3,
    height: 3.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-screen-high",
    x: 78.19,
    y: 85.25,
    width: 3,
    height: 3.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-high",
    d: "M78.19,56.48v25.9h3V56.17a2.7,2.7,0,0,0-2.69-2.69H60.15v3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-high",
    d: "M73.5,82.38h3V61.08a2.7,2.7,0,0,0-2.69-2.7H54.33v3H73.5Zm.32-21h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-screen-high",
    x: 54.33,
    y: 53.48,
    width: 2.81,
    height: 3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-high",
    d: "M24.24,58.38a2.69,2.69,0,0,0-2.69,2.7V76.29H19.86V56.48H51.33v-3H19.55a2.7,2.7,0,0,0-2.69,2.69V77.79a1.5,1.5,0,0,0,1.5,1.5h4.69a1.51,1.51,0,0,0,1.5-1.5V61.38H51.33v-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-high",
    d: "M27,91h25.3l-.11-.09H27a1.58,1.58,0,0,0-1.5,1.59A1.5,1.5,0,0,1,27,91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-high",
    d: "M79.59,93.75h4.5v-.07a2.68,2.68,0,0,0-1.26-2.26H81.18A2.68,2.68,0,0,1,79.59,93.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-high",
    d: "M78.15,96.78H28.7l0,0a3.66,3.66,0,0,1-.15-.82V94H27a1.5,1.5,0,0,1-1.5-1.5v3.42a5,5,0,0,0,.17,1.25,1.5,1.5,0,0,0,1,2.62H80a4.06,4.06,0,0,0,3.89-2.92H78.61A1.39,1.39,0,0,1,78.15,96.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-high",
    d: "M27,94H77.79a1.54,1.54,0,0,1,.82-.24h1a2.68,2.68,0,0,0,1.59-2.33H53.67A2.3,2.3,0,0,1,52.33,91H27a1.5,1.5,0,0,0,0,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-high",
    d: "M134.23,34.86H53.67a2.35,2.35,0,0,0-2.34,2.35V53.48h3V37.86h79.24V88.42H81.19V91h.2a2.62,2.62,0,0,1,1.44.43h51.4a2.35,2.35,0,0,0,2.34-2.35V37.21A2.35,2.35,0,0,0,134.23,34.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-high",
    d: "M76.5,91V88.42h-3V90.9H52.22l.11.09Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-screen-high",
    x: 78.19,
    y: 88.42,
    width: 3,
    height: 2.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-screen-high",
    x: 51.33,
    y: 53.48,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-screen-high",
    x: 51.33,
    y: 58.38,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-high",
    d: "M81.19,91v.31s0,.07,0,.12h1.65A2.62,2.62,0,0,0,81.39,91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-high",
    d: "M76.5,91H52.33a2.3,2.3,0,0,0,1.34.43H81.18s0-.08,0-.12V91H76.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-high",
    d: "M60.59,43.15h66.72a1.15,1.15,0,0,1,1.18,1.13V63.14a.76.76,0,0,0,1.52,0V43.22a1.51,1.51,0,0,0-1.57-1.44h-69a1.51,1.51,0,0,0-1.57,1.44V53.48H59.4v-9.2A1.16,1.16,0,0,1,60.59,43.15Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-screen-high",
    x: 57.89,
    y: 53.48,
    width: 1.52,
    height: 3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-high",
    d: "M57.51,43.22a1.88,1.88,0,0,1,2-1.81h69a1.88,1.88,0,0,1,1.95,1.81V63.14a1.14,1.14,0,0,1-2.27,0V44.28a.78.78,0,0,0-.81-.76H60.59a.78.78,0,0,0-.81.76v9.2h.37v-9.2a.42.42,0,0,1,.44-.38h66.72a.41.41,0,0,1,.43.38V63.14a1.51,1.51,0,0,0,3,0V43.22A2.26,2.26,0,0,0,128.44,41h-69a2.26,2.26,0,0,0-2.32,2.19V53.48h.37Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-screen-high",
    x: 57.14,
    y: 53.48,
    width: 0.38,
    height: 3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-high",
    d: "M58.65,58.39h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-screen-high",
    x: 59.78,
    y: 53.48,
    width: 0.38,
    height: 3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-high",
    d: "M57.89,43.22a1.51,1.51,0,0,1,1.57-1.44h69A1.51,1.51,0,0,1,130,43.22V63.14a.76.76,0,0,1-1.52,0V44.28a1.15,1.15,0,0,0-1.18-1.13H60.59a1.16,1.16,0,0,0-1.19,1.13v9.2h.38v-9.2a.78.78,0,0,1,.81-.76h66.72a.78.78,0,0,1,.81.76V63.14a1.14,1.14,0,0,0,2.27,0V43.22a1.88,1.88,0,0,0-1.95-1.81h-69a1.88,1.88,0,0,0-2,1.81V53.48h.38Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-screen-high",
    x: 57.51,
    y: 53.48,
    width: 0.37,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-screen-high",
    x: 59.4,
    y: 53.48,
    width: 0.37,
    height: 3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-high",
    d: "M128.44,84.5A1.51,1.51,0,0,0,130,83.06V73.38a.76.76,0,0,0-1.52,0V82a1.16,1.16,0,0,1-1.18,1.13H81.19V84.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-screen-high",
    x: 78.19,
    y: 83.13,
    width: 3,
    height: 1.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-screen-high",
    x: 73.5,
    y: 83.13,
    width: 3,
    height: 1.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-high",
    d: "M127.31,82.76a.78.78,0,0,0,.81-.76V73.38a1.14,1.14,0,0,1,2.27,0v9.68a1.88,1.88,0,0,1-1.95,1.81H81.19v.38h47.25a2.26,2.26,0,0,0,2.32-2.19V73.38a1.51,1.51,0,0,0-3,0V82a.41.41,0,0,1-.43.38H81.19v.38Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-screen-high",
    x: 78.19,
    y: 84.87,
    width: 3,
    height: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-screen-high",
    x: 73.5,
    y: 82.38,
    width: 3,
    height: 0.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-screen-high",
    x: 73.5,
    y: 84.87,
    width: 3,
    height: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-screen-high",
    x: 78.19,
    y: 82.38,
    width: 3,
    height: 0.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-high",
    d: "M127.31,83.13A1.16,1.16,0,0,0,128.49,82V73.38a.76.76,0,0,1,1.52,0v9.68a1.51,1.51,0,0,1-1.57,1.44H81.19v.37h47.25a1.88,1.88,0,0,0,1.95-1.81V73.38a1.14,1.14,0,0,0-2.27,0V82a.78.78,0,0,1-.81.76H81.19v.37Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-screen-high",
    x: 78.19,
    y: 82.76,
    width: 3,
    height: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-screen-high",
    x: 78.19,
    y: 84.5,
    width: 3,
    height: 0.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-screen-high",
    x: 73.5,
    y: 82.76,
    width: 3,
    height: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-screen-high",
    x: 73.5,
    y: 84.5,
    width: 3,
    height: 0.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-high",
    d: "M84.05,96.11h24.31a.81.81,0,1,0,0-1.61H84.09v1.21C84.09,95.85,84.06,96,84.05,96.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-high",
    d: "M84.09,95.71V94.5h-3v1.21a1.06,1.06,0,0,1-.08.4h3C84.06,96,84.09,95.85,84.09,95.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-high",
    d: "M108.36,94.13a1.18,1.18,0,0,1,0,2.36H84c0,.13-.07.25-.11.37h24.46a1.56,1.56,0,1,0,0-3.11H84.09v.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-high",
    d: "M78.5,94h2.59v.14h3v-.38h-4.5A2.63,2.63,0,0,1,78.5,94Zm2.9,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-high",
    d: "M80.75,96.49a1.09,1.09,0,0,1-.74.29H78.15a1.39,1.39,0,0,0,.46.08H83.9c0-.12.08-.24.11-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-high",
    d: "M77.79,94h.71a2.63,2.63,0,0,0,1.09-.24h-1A1.54,1.54,0,0,0,77.79,94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-high",
    d: "M108.36,94.5a.81.81,0,1,1,0,1.61H84.05c0,.13,0,.26,0,.38h24.35a1.18,1.18,0,0,0,0-2.36H84.09v.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-high",
    d: "M81,96.11a1.12,1.12,0,0,1-.26.38H84c0-.12,0-.25,0-.38Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-screen-high",
    x: 81.09,
    y: 94.13,
    width: 3,
    height: 0.37
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreensHigh);
export default __webpack_public_path__ + "static/media/screens-high.3215cc68.svg";
export { ForwardRef as ReactComponent };